<template lang="pug">
    .animation(ref='animation')
        .knives
            .knife(v-for='item in 3' ref='knife')
                img(src='../../assets/img/animations/knife.svg')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('top-bottom', 'middle-middle');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline.fromTo(this.$refs.knife, {x: '200%'}, {duration: 1, x: '0', ease: 'none', stagger: {each: 1}}, 0);
            this.timeline.progress(0.0001);
            this.timeline.pause();
        }
    }
};
</script>
<style lang="scss" scoped>
.animation {
    display: flex;
    align-items: center;
    justify-content: center;
}
.knife {
    padding: 20px 0;
}
</style>
